'use client';

import { useEffect } from 'react';

// Scrolle vers l'ancre de l'URL (#documents, #teams, #faq…) au chargement de la page projet.
// L'ancre native ne fonctionne pas de façon fiable ici (hydratation + images qui décalent le
// layout après le premier rendu) : on réessaie quelques fois jusqu'à trouver l'élément, puis
// on scrolle une fois le layout stabilisé.
const ScrollToHash = () => {
  useEffect(() => {
    const id = decodeURIComponent(window.location.hash.replace(/^#/, ''));
    if (!id) {
      return;
    }

    let attempts = 0;
    let timer: ReturnType<typeof setTimeout>;

    const scrollToTarget = () => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      // La section peut ne pas être encore rendue (ou pas affichée si non connecté).
      if (attempts < 20) {
        attempts += 1;
        timer = setTimeout(scrollToTarget, 200);
      }
    };

    scrollToTarget();

    return () => clearTimeout(timer);
  }, []);

  return null;
};

export default ScrollToHash;
